import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Stack from "react-bootstrap/Stack";
import { getLink } from "../common/appLinkBuilder";

class Footer extends React.Component {
  state = {};
  render() {
    return (
      <Container fluid className="bg-primary text-white mt-auto py-1 fixed-bottom">
        <Row>
          <Col>
            <Stack direction="horizontal" gap={2}>
              <span>© 2023 ATS. Powered by</span>
              <span className="bg-primary p-2">
                <a href="https://ats.tennis" rel="nofollow">
                  <img src={getLink("default.logo.png")} height="30" alt="" />
                </a>
              </span>
            </Stack>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Footer;
